export default __webpack_public_path__ + "static/media/vendingmachine.9df92576.png";